module.exports = __webpack_public_path__ + "img/round_bf.411cf600.svg";